import {
  LayoutDashboard,
  FileCheck,
  Users,
  Wallet,
  Settings,
  Shield,
  Package,
  Box,
  Building,
  ScrollText,
  Receipt,
  Wrench,
  Calendar,
  CalendarCheck,
  ClipboardList,
  CheckSquare,
  Truck,
  Hammer,
  MapPin,
  Clock,
  Smartphone,
  UsersRound,
  MessageSquare,
  MessagesSquare,
  TrendingUp,
  Megaphone,
  Tag,
  FileInput,
  Zap,
  DollarSign,
  CreditCard,
  BarChart3,
  User,
  ShieldCheck,
  Plug,
  Bell,
  FileSignature,
  FileText,
  type LucideIcon,
} from "lucide-react";

export interface NavChild {
  id: string;
  label: string;
  href: string;
  icon: LucideIcon;
  notImplemented?: boolean;
}

export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  href?: string;
  children?: NavChild[];
  adminOnly?: boolean;
}

export const navigationConfig: NavItem[] = [
  // 1. Dashboard - Direct link
  {
    id: "dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
    href: "/dashboard",
  },

  // 2. Sales (Money In)
  {
    id: "sales",
    label: "Sales",
    icon: FileCheck,
    children: [
      { id: "estimates", label: "Estimates & Takeoffs", href: "/estimates", icon: FileCheck },
      { id: "invoices", label: "Invoices", href: "/invoices", icon: Receipt },
      { id: "customer-credits", label: "Customer Credits", href: "/finances/credit-notes", icon: FileText },
    ],
  },

  // 3. Cost Center (Money Out)
  {
    id: "cost-center",
    label: "Cost Center",
    icon: Wallet,
    children: [
      { id: "assemblies", label: "Assemblies", href: "/cost-center/assemblies", icon: Package, notImplemented: true },
      { id: "internal-line-items", label: "Line Items", href: "/cost-center/internal-line-items", icon: Box },
      { id: "overheads", label: "Fixed Overheads", href: "/cost-center/overheads", icon: Building, notImplemented: true },
      { id: "pricing-settings", label: "Pricing Settings", href: "/cost-center/settings", icon: Settings },
    ],
  },

  // 4. Projects & Scheduling
  {
    id: "projects",
    label: "Projects & Scheduling",
    icon: Wrench,
    children: [
      { id: "active-projects", label: "Active Projects", href: "/projects", icon: Wrench },
      { id: "calendar", label: "Calendar", href: "/scheduling/calendar", icon: Calendar, notImplemented: true },
      { id: "appointments", label: "Appointments", href: "/scheduling/appointments", icon: CalendarCheck, notImplemented: true },
      { id: "maintenance", label: "Maintenance Schedules", href: "/scheduling/maintenance", icon: ClipboardList, notImplemented: true },
      { id: "tasks", label: "Tasks & Punch Lists", href: "/scheduling/tasks", icon: CheckSquare, notImplemented: true },
    ],
  },

  // 5. People
  {
    id: "people",
    label: "People",
    icon: Users,
    children: [
      { id: "customers", label: "Customers", href: "/customers", icon: Users },
      { id: "suppliers", label: "Suppliers", href: "/cost-center/suppliers", icon: Truck },
      { id: "team", label: "Team & Crews", href: "/people/team", icon: UsersRound },
    ],
  },

  // Categories below are fully "Coming Soon" - all children are notImplemented
  // They are hidden from navigation but routes still work for future activation
  // Fleet & Equipment, Workforce, Communication, Growth Center

  // 10. Finances (Coming Soon - all items are not implemented)
  // Removed from main nav since all children are notImplemented
  // Will be added back when features are ready

  // 11. Settings
  {
    id: "settings",
    label: "Settings",
    icon: Settings,
    children: [
      { id: "company-settings", label: "Company", href: "/settings", icon: Building },
      { id: "profile", label: "Profile", href: "/settings/profile", icon: User },
      { id: "document-defaults", label: "Document Defaults", href: "/cost-center/document-defaults", icon: ScrollText },
      { id: "compliance", label: "Compliance & Certs", href: "/settings/compliance", icon: ShieldCheck, notImplemented: true },
      { id: "integrations", label: "Integrations", href: "/settings/integrations", icon: Plug, notImplemented: true },
      { id: "notifications", label: "Notifications", href: "/settings/notifications", icon: Bell, notImplemented: true },
    ],
  },

  // 12. Admin Dashboard - Direct link (adminOnly)
  {
    id: "admin",
    label: "Admin Dashboard",
    icon: Shield,
    href: "/admin",
    adminOnly: true,
  },
];
